require('../../sass/generate-template/index.scss')

import Vue from 'vue'
import CryptoJS from 'crypto-js';
import Clipboard from "clipboard";
import VueResource from 'vue-resource'
import MobileDetect from 'mobile-detect'
import Toast from '../../components/toast/toast'
import downloadApp from '../common/download-app';
import Modal from '../xhpopulrz/util/modal'
import { localStore } from '@xhtech/lux'
// let ajax = require('../common/ajax/ajax.js');
import { isWeiXin, getParam, storage, showLoading, closeLoading, splitHost, isAddGw } from '../common/util'
import { getTracker, track, getTrackerByType, getTimer, getCopyrightJs } from './track2'
import xha from '@xhtech/xhanalysis-sdk'
import CaptchaDialog from '../../../web/components/captchaDialog';
import Dialog from '../../../web/components/dialog';




Vue.use(VueResource)
Vue.use(Modal)
Vue.use(CaptchaDialog)
Vue.use(Dialog);

const host = splitHost(location.host);
// 埋点 sdk 初始化
console.log('env', env.env);
console.log('prod', env.prod);
// console.log("ajax", ajax)

xha.init({
  appId: 'h5-mobile',
  api: env.env === 'production'
    ? '//sp.' + host + '/sp'
    : '//sptest.xiaohuaai.com/sp',
  env: env.env
})
xha.sdRegisterPage({
  appId: 'h5-mobile',
  clientVersion: '1.1'
})
document.addEventListener('visibilitychange', function () {
  let pageVisibility = document.visibilityState
  // 页面变为不可见时触发
  if (pageVisibility == 'hidden') {
    if (BUSINESS_GROUP !== 'BGXWD') {
      xha.trackEvent('EnterPageV2', {
        channel_id: appChannel,
        $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花落地页页面离开' : '小花钱包落地页页面离开',
        platform_type: 'H5',
        PreviosPageTitle: '',
        pageStatus: '',
        $url: location.href
      })
    }
  }
})
if (BUSINESS_GROUP !== 'BGXWD') {
  xha.trackEvent('EnterPageV2', {
    channel_id: appChannel,
    $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花落地页页面进入' : '小花钱包落地页页面进入',
    platform_type: 'H5',
    PreviosPageTitle: '',
    pageStatus: '',
    $url: location.href
  })
}
const appChannel = getParam('appChannel')       // 渠道
const status = getParam('status')       // 页面状态
const md = new MobileDetect(navigator.userAgent)
const ua = detector.parse(navigator.userAgent)
const isWeChat = isWeiXin()
const trackType = getParam('track_type')

const devicePixelRatio = window.devicePixelRatio
const screen = window.screen
const deviceID = storage.get('fppDeviceId') || Guid.create().value

storage.set('fppDeviceId', deviceID, { expires: 30, path: '/' })

const extraParams = {
  deviceID,
  deviceType: md.mobile() || '',
  deviceName: md.phone() || '',
  appChannel: appChannel || '',
  clientPlatform: md.os() || '',
  brand: ua.device.manufacturer || '',
  osversion: ua.os.version || '',
  resolution: (screen.width * devicePixelRatio) + 'X' + (screen.height * devicePixelRatio),
  channelName: 'WEB',
  referralType: 'MGM01'
}

magnus.init({
  tacticsConfig: {
    product: 1,
    platform_type: 3,
    version: '1.0.0'
  }
})

const errorMsg = '很抱歉,网络异常,请稍后重试'

const trackName = trackType ? getTrackerByType(trackType) : getTracker(appChannel)

// 腾讯广点通、微信、头条、百度API对接
let useOurStatisticsFlag = false;
// 如果是以下渠道则调用我们的api进行数据统计，否则在页面中加载对方统计代码
// 1、有trackType参数 2、trackType后缀是api。都满足以上两者才会调用api

if (trackType && trackType.split('-')[trackType.split('-').length - 1] === 'api') {
  // 新统计方法，使用自己的api接口
  console.log('新统计方法')
  useOurStatisticsFlag = true;
} else {
  // 旧统计方法，下载合作方的统计代码
  console.log('旧统计方法')
  console.log('xha')
  track[trackName] && track[trackName].init()
}

Vue.http.interceptors.push((req, next) => {
  req.body = Object.assign({}, req.body, extraParams)
  req.body.businessGroup = BUSINESS_GROUP === "BGXWD" ? BUSINESS_GROUP : "BGALL"
  if (isAddGw()) {
    let flag = req.url.includes('/weixinh5/weixin/getUrlScheme')
    if (!flag) {
      req.url = `/gw${req.url}`
    }
  }
  next(resp => {
  })
})

new Vue({
  el: '#app',
  components: {
    Toast,
  },
  data: {
    phoneNumber: '',
    captcha: '',
    passcodeTag: '',
    captchaText: '获取验证码',
    isGetCaptcha: false,
    pageStatus: status || 'register',
    registerResult: '',
    protocolUrl: '',
    encryption: '',
    isXhCustomer: '',
    mode: '',
    pageDetail: '',
    disabled: false, // 尊享花App简版 验证码按钮
    isZxhAppSimple: false, // 是否是尊享花业务线下的App（简版）
    isZxhAppCommon: false, // 是否是尊享花业务线下的App（通用版）
    isShowCaptcha: false,// 是否展示验证码输入框
  },
  created() {
    getCopyrightJs(window.landingEnv);
    this.mode = getParam('mode')
    this.pageDetail = getParam('pageDetail')

    if (BUSINESS_GROUP === 'BGALL' && jumpPlat === 'downloadApp' && autoDownload === 1) {
      this.downloadApp()
    }
    this.isZxhAppSimple = BUSINESS_GROUP === 'BGALL-ZXH' && jumpPlat === 'APPSimple'
    this.isZxhAppCommon = BUSINESS_GROUP === 'BGALL-ZXH' && jumpPlat === 'F_APP_GENERAL'
    if (this.isZxhAppCommon && localStore.get('zxhPhone') && this.pageStatus !== 'completed') {
      this.pageStatus = 'completed'
      this.handleTimeDown()
      this.downloadBtnCounter()
      this.clickDownloadApp()
    }

    /* 页面埋点 */
    let url = window.location.href.toLocaleLowerCase()
    url = url.substr(url.indexOf('/client') + 8)
    let fir = url.substr(0, url.indexOf('/'))
    fir = fir.replace(/[-]/g, '')
    let secon = url.substr(url.indexOf('/') + 1)
    secon = secon.slice(0, secon.length - 5)

    if (BUSINESS_GROUP === 'BGXWD') {
      xha.trackEvent('EnterPageV2', {
        $title: '竹叶小微注册下载页',
        channel_id: appChannel,
        platform_type: 'H5',
        page_status: '',
        page_access_time: Date.now(),
        enterTime: getTimer(),
        $url: location.href
      })
    } else {
      xha.trackEvent('EnterPageV2', {
        channel_id: appChannel,
        $title: '小花钱包注册下载页',
        platform_type: 'H5',
        PreviosPageTitle: '',
        pageStatus: this.pageStatus,
        $url: location.href
      })
    }
  },
  ready() {
    // 微信分享
    if (isWeChat) {
      let url = location.href
      url = url.indexOf('referralCode') >= 0 && url.replace('referralCode', 'preReferralCode')
      try {
        weixin(true, {
          title: document.title,
          des: document.getElementsByTagName('meta')['description'].content,
          business: BUSINESS_GROUP,
          url
        })
      } catch (error) {
        // console.log(error)
      }
    }

    const businessMap = {
      BGXWD: 'zyxw',
      BGALL: 'xiaohua',
      "BGALL-ZXH": 'zxh'
    }

    magnus.entryHandle('xhqbFrontEndH5Entry27Num',
      {
        login_status: 0,
      },
      {
        page_embed_source: 3,
        bel_product: businessMap[BUSINESS_GROUP] || 'xiaohua',
        channel_id: appChannel
      }
    )
    // 协议
    switch (BUSINESS_GROUP) {
      case 'BGALL':
        this.protocolUrl = '/m/protocols/customerservice/customerService.html'
        break
      case 'BGBT':
        this.protocolUrl = '/bt/protocols/customerservice/customerService.html'
        break
      default:
        this.protocolUrl = '/m/protocols/customerservice/customerService.html'
        break
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mixins: [downloadApp],
  methods: {
    verifyPhoneNumber(phoneNumber) {
      if (!phoneNumber) {
        this.$refs.toast.show('请输入手机号码')
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phoneNumber)) {
        this.$refs.toast.show('请输入正确的手机号码')
      } else {
        return true
      }
      return false
    },
    // goToWeapp(path) {
    //   ajax.get(this, '/weixinh5/weixin/getUrlScheme', {
    //     appChannel:'',
    //     path:path,
    //     service: 'wxAppletJsj'
    //   }, function (resp) {
    //     console.log("resp",resp)
    //     if (resp.success) {
    //       location.href = resp.urlScheme
    //     }
    //   })

    // },
    activityJump(skipType, jumpLinkType) {
      if (isWeChat && jumpLinkType) {
        if (skipType === 'pages/home/index' || skipType === 'pages/my/index') {
          const newStr = skipType.replace("pages", "..")
          wx.miniProgram.switchTab({ url: newStr })
        } else {
          const newStr = skipType.replace("pages", "..")
          wx.miniProgram.navigateTo({ url: newStr })
        }
      }
      if (!isWeChat) {
        location.href = `/${skipType}`
      }
    },
    clickPrivate(e) { // 《隐私政策》
      magnus.clickHandle('xhqbFrontEndH5Click31Num', {
        login_status: 0,
      }, {
        page_embed_source: 3,
        page_status: status,
        channel_id: appChannel
      })
      const href = e.target.href
      window.location.href = href
    },
    clickService(e) {
      magnus.clickHandle('xhqbFrontEndH5Click32Num', {
        login_status: 0,
      }, {
        page_embed_source: 3,
        page_status: status,
        channel_id: appChannel
      })
      const href = e.target.href
      window.location.href = href
    },
    clickInput() {
      xha.trackEvent('InputPhoneNumber', {
        'channel_id': appChannel
      })
      xha.trackEvent('ElementClickV2', {
        elementName: '输入手机号',
        $url: location.href,
        platform_type: 'H5'
      })
    },
    // 尊享花App（通用版）下载安装包
    clickDownloadApp() {
      if (md.os() === 'iOS') { //ios跳转小程序
        this.downloadApp()
      } else {
        window.location.href = downloadLink
      }
    },

    // 倒计时
    handleTimeDown() {
      var h = countdownHour;
      var m = countdownScore;
      var s = countdownSeconds;
      var oTime = document.getElementById("countdown");
      oTime.innerHTML = '还剩' + quotaStart + '个名额,' + this.formatTime(h, m, s) + '后失效';
      //进行倒计时显示
      var time = setInterval(() => {
        --s;
        if (s < 0) {
          --m;
          s = 59;
        }
        if (m < 0) {
          --h;
          m = 59
        }
        if (h < 0) {
          s = 0;
          m = 0;
        }
        if (h == 0 && m == 0 && s == 0) {
          clearInterval(time)
          oTime.style.display = 'none'
        }
        oTime.innerHTML = '还剩' + quotaStart + '个名额,' + this.formatTime(h, m, s) + '后失效'
      }, 1000);
    },
    // 格式化时间
    formatTime(h, m, s) {
      return (h + ":" + m + ":" + s).replace(/\b(\w)\b/g, '0$1')
    },

    getCaptcha(fromType = '', isLoanBtn = false) {
      if (this.isGetCaptcha) return;

      if (this.verifyPhoneNumber(this.phoneNumber)) {
        if (BUSINESS_GROUP === 'BGXWD') {
          xha.trackEvent('ElementClickV2', {
            $title: '竹叶小微注册下载页',
            elementName: '获取验证码',
            page_status: '',
            elementType: '按钮',
            $url: location.href,
            element_text: '获取验证码',
            platform_type: 'H5'
          })
        } else {
          xha.trackEvent('ElementClickV2', {
            elementType: '按钮',
            $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花注册下载页' : '小花钱包注册下载页',
            $url: location.href,
            elementName: '获取验证码',
            elementText: '获取验证码',
            platform_type: 'H5'
          })
        }

        this.isGetCaptcha = true
        this.$http.post('/auth/genToken', {
          phoneNum: this.phoneNumber,
          bizType: 'register',
        }).then(resp => {
          const token = resp.headers.token
          const data = resp.json()
          magnus.clickHandle('xhqbFrontEndH5Click28Num',
            { login_status: 0 },
            {
              page_status: status,
              page_embed_source: 3,
              channel_id: appChannel,
              result: '',
              fail_reason: '',
            }
          )
          if (data.success) {
            this.$http.post('/auth/pass/sendRegisterPass', {
              phoneNum: this.phoneNumber,
              bizType: 'register',
            }, {
              headers: token
            }).then(resp => resp.json())
              .then(resp => {
                if (resp.success) {
                  if (fromType === 'appSimple') {
                    this.handleTime(isLoanBtn, fromType)
                  } else {
                    this.counter().then(() => {
                      this.isGetCaptcha = false
                    })
                  }
                  if (resp.resultCode === 'SUCCESS') {
                    this.passcodeTag = resp.passcodeTag
                    this.$refs.toast.show('验证码发送成功')
                  } else {
                    this.$refs.toast.show(resp.resultMsg)
                  }
                } else {
                  this.isGetCaptcha = false
                  this.$refs.toast.show(resp.resultMsg || errorMsg)
                }
              }).catch(error => {
                this.isGetCaptcha = false
                this.$refs.toast.show(resp.resultMsg || errorMsg)
              })
          } else {
            magnus.clickHandle('xhqbFrontEndH5Click28Num',
              { login_status: 0 },
              {
                result: data.success,
                fail_reason: data.resultMsg || '获取验证码token失败',
                page_status: status,
                page_embed_source: 3,
                channel_id: appChannel
              }
            )
            this.isGetCaptcha = false
            this.$refs.toast.show(data.resultMsg || '获取验证码token失败', 2000)
          }
        })
      }
    },
    counter(fromType = '') {
      return new Promise((resolve, reject) => {
        try {
          let leftTime = 60
          const captchaId = document.getElementById('captcha')
          if (captchaId) {
            captchaId.innerHTML = fromType ? '重发验证码' : (this.isZxhAppCommon ? '重发' : `${leftTime}秒后发送`)
          }
          this.interval = setInterval(() => {
            leftTime--

            if (leftTime <= 0) {
              clearInterval(this.interval)
              if (captchaId) {
                captchaId.innerHTML = fromType ? '重发验证码' : (this.isZxhAppCommon ? '重发' : '获取验证码')
                if (this.isZxhAppSimple || this.isZxhAppCommon) { // 当是尊享花 App（简版）时，倒计时结束后获取验证码按钮可点击并高亮（样式变化）
                  this.disabled = false
                  captchaId.disabled = false;
                }
              }
              resolve()
            } else {
              if (captchaId) {
                captchaId.innerHTML = fromType ? `已发送${leftTime}s` : (this.isZxhAppCommon ? `重发${leftTime}s` : `${leftTime}秒后发送`)
                if (this.isZxhAppSimple || this.isZxhAppCommon) {// 当是尊享花 App（简版）时，倒计时未结束 获取验证码按钮不可点击并置灰
                  this.disabled = true
                  captchaId.disabled = true;
                }
              }
            }
          }, 1000)
        } catch (error) {
          console.log('error', error)
        }
      })
    },
    downloadBtnCounter() {
      return new Promise((resolve, reject) => {
        try {
          let leftTime = 3
          const downloadBtn = document.getElementById('downloadBtn')
          const timer = setInterval(() => {
            if (leftTime <= 0) {
              clearInterval(timer)
              if (downloadBtn) {
                downloadBtn.innerHTML = '下载APP借款'
                downloadBtn.disabled = false
              }
              resolve()
            } else {
              if (downloadBtn) {
                downloadBtn.innerHTML = `下载APP借款(0${leftTime}s)`
                downloadBtn.disabled = true
              }
            }
            leftTime--
          }, 1000)
        } catch (error) {
          console.log('error', error)
        }
      })
    },

    verifyCaptcha: function (captcha) {
      let errMsg

      if (!this.passcodeTag) {
        errMsg = '请先获取验证码'
      } else if (!captcha) {
        errMsg = '请输入验证码'
      } else if (captcha.length < 6) {
        errMsg = '请输入6位验证码'
      }

      if (errMsg) {
        this.$refs.toast.show(errMsg)
        return false
      } else {
        return true
      }
    },
    getIsXhCustomer() {
      return new Promise((resolve, reject) => {
        if (BUSINESS_GROUP === 'BGXWD') {
          this.$http.post('/xwd-api/thirdPartyUser/preRegistration', {
            phone: this.phoneNumber,
            operationType: '10',
            channel: appChannel,
            carrier: detector.os.name === 'ios' ? '80' : '90',
            channelCode: detector.os.name === 'ios' ? 'IOS' : 'ANDROID'
          }).then(resp => resp.json())
            .then(resp => {
              if (resp.success) {
                console.log('resp', resp.data.isXhCustomer)
                resolve(resp)
              } else {
                xha.trackEvent('EnterPageV2', {
                  $title: '小花老客接口',
                  phone: this.phoneNum,
                  result: resp
                })
                reject(resp)
              }
            }).catch(error => {
              xha.trackEvent('EnterPageV2', {
                $title: '小花老客接口',
                phone: this.phoneNum,
                err: error
              })
              reject(error)
            })
        } else {
          resolve()
        }
      })
    },
    newOurStatisticsApi(operationType, appChannel, businessGroup, cb) {
      console.log('isXhCustomer', this.isXhCustomer)
      const clickTime = Date.now();
      const mobile = this.phoneNumber;
      const channel = location.href.split("directing=")[1] || ''
      const clickId = getParam('clickid') || getParam('clickId') || getParam('click_id') || getParam('qz_gdt') || null;
      if (useOurStatisticsFlag) {
        this.isXhCustomer !== '1' && this.$http.post('/gondarfront-in/clueTrack/registerSuccess', {
          operationType: operationType,
          appChannel: appChannel,
          businessGroup: businessGroup,
          clickId: clickId,
          clickTime: clickTime,
          mobile: mobile,
          trackType: trackType,
          h5Url: location.href,
          callback: location.href.split('?')[1],
        }, function (resp) {
          if (resp.success) {
            cb();
          }
        }, function (error) {
          this.$refs.toast.show(error)
        }
        )
      } else {
        // 旧方法,js
        track[trackName] && track[trackName].action()
        if (channel.indexOf("&")) {
          if (channel.split("&")[0] === "h5pro") {
            location.href = "/application/home?appChannel=xhqbcs"
          }
        } else {
          if (channel === "h5pro") {
            location.href = "/application/home?appChannel=xhqbcs"
          }
        }
      }
    },

    submit(e) {
      if (BUSINESS_GROUP === 'BGALL-ZXH') {
        console.log('尊享花剪切板submit');
        this.copyToClipboard();
      }
      if (BUSINESS_GROUP === 'BGXWD') {
        xha.trackEvent('ElementClickV2', {
          $title: '竹叶小微注册下载页',
          elementName: '立即注册',
          page_status: '',
          elementType: '按钮',
          $url: location.href,
          element_text: '立即注册',
          platform_type: 'H5',
          target_page_title: '竹叶小微注册下载结果页'
        })
      } else {
        xha.trackEvent('ElementClickV2', {
          elementType: '按钮',
          $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花注册下载页' : '小花钱包注册下载页',
          $url: location.href,
          elementName: '立即注册',
          elementText: '立即注册',
          platform_type: 'H5'
        })
      }
      if (this.isZxhAppSimple) {//尊享花App（简版）走另外逻辑
        xha.trackEvent('ElementClickV2', {
          elementName: '查看我的额度',
          $url: location.href,
          platform_type: 'H5',
        })
        this.zxhSimpleSubmit()
        return
      }
      if (!this.isShowCaptcha && this.isZxhAppCommon) { //尊享花App（通用版）首次点击提交按钮时展示验证码区域
        if (!this.verifyPhoneNumber(this.phoneNumber)) return
        this.isShowCaptcha = true
        this.getCaptcha('', true)
        return
      }
      this.handleRegister()
    },

    zxhSimpleSubmit() {
      if (!this.verifyPhoneNumber(this.phoneNumber)) return
      if (!this.disabled) {
        // true 代表点击入口是 submit 按钮
        this.getCaptcha('appSimple', true)
        return
      }
      let _this = this;
      setTimeout(() => {
        _this.$CaptchaDialog({
          btns: {
            getCode() {
              _this.getCaptcha('appSimple', false)
            },
            onChange(value) {
              _this.handleCodeChange(value)
            }
          },
          code: _this.captcha,
          phoneNum: _this.phoneNumber,
        });
      }, 1000)
    },

    clearVerify() {
      clearInterval(this.interval)
      this.disabled = false
      this.captcha = ''
    },

    handleTime(isLoanBtn, fromType) {
      this.clearVerify()
      let _this = this;
      //为true代表是点击外部 submit 按钮入口进来的 此时需要调起弹窗 开始倒计时
      isLoanBtn && setTimeout(() => {
        _this.$CaptchaDialog({
          btns: {
            getCode() {
              _this.getCaptcha('appSimple', false)
            },
            onChange(value) {
              _this.handleCodeChange(value)
            }
          },
          code: _this.captcha,
          phoneNum: _this.phoneNumber,
        });
        document.getElementById("captcha").disabled = false;
        this.counter(fromType).then(() => {
          this.isGetCaptcha = false
        })
      }, 1000)
      //为false代表是点击 重发验证码 按钮入口进来的 此时只需要重新开始倒计时
      if (!isLoanBtn) {
        this.counter(fromType).then(() => {
          this.isGetCaptcha = false
        })
      }
    },

    //验证码输入框赋值
    handleCodeChange(value) {
      this.captcha = value.replace(/[^\d]/g, '').slice(0, 6)
      if (this.captcha.length === 6 && this.disabled && this.verifyCaptcha(this.captcha)) {
        this.handleRegister()
      }
    },

    handleRegister() {
      const business = BUSINESS_GROUP === "BGXWD" ? BUSINESS_GROUP : "BGALL";
      if (this.verifyPhoneNumber(this.phoneNumber) && this.verifyCaptcha(this.captcha)) {
        magnus.clickHandle('xhqbFrontEndH5Click29Num', {
          login_status: 0,
        }, {
          page_status: status,
          page_embed_source: 3,
          channel_id: appChannel,
          result: '',
          fail_reason: '',
        })
        this.isSubmiting = true
        this.getIsXhCustomer().then(
          (resp) => {
            if (resp && resp.data && resp.data.isXhCustomer) {
              this.isXhCustomer = resp.data.isXhCustomer
            }
            console.log('resp', resp, this.isXhCustomer)
            this.$http.post('/auth/user/register', {
              phoneNum: this.phoneNumber,
              smsPasscode: this.captcha,
              passcodeTag: this.passcodeTag,
              businessGroup: business,
            }).then(resp => resp.json())
              .then(resp => {
                const channel = location.href.split("directing=")[1] || ''
                this.isSubmiting = false
                if (resp.customerIdMD5) {
                  xha.sdLogin(resp.customerIdMD5)
                }
                // 下载页访问 失败成功都会访问下载页
                if (resp.success) {
                  if (BUSINESS_GROUP === "BGXWD") {
                    xha.trackEvent('EnterPageV2', {
                      $title: '竹叶小微注册下载结果页',
                      channel_id: appChannel,
                      platform_type: 'H5',
                      page_status: '',
                      page_access_time: Date.now(),
                      enterTime: getTimer(),
                      $url: location.href
                    })
                    xha.trackEvent('RegiResult', {
                      $title: '竹叶小微注册下载结果页',
                      channel_id: appChannel,
                      fail_reason: '',
                      result: '1'
                    })
                  } else {
                    xha.trackEvent('RegiResult', {
                      channel_id: appChannel,
                      fail_reason: '',
                      result: '1'
                    })
                  }
                  this.$refs.toast.show('注册成功', 2000, () => {
                    clearInterval(this.interval)
                    this.disabled = false
                  })
                  if (this.isZxhAppSimple) {
                    this.captcha = ''
                    document.getElementById("captcha-dialog").remove()
                    this.isGetCaptcha = false
                  }
                  if (this.isZxhAppSimple && openPageType === 'XCX') {
                    this.openMiniApp()
                  } else {
                    this.pageStatus = 'completed'
                  }
                  this.registerResult = 'NEW_USER'
                  if (this.isZxhAppCommon) {
                    this.downloadBtnCounter()
                    this.clickDownloadApp()
                    //名额倒计时
                    this.handleTimeDown()
                    localStore.set('zxhPhone', this.phoneNumber)
                  }
                  this.newOurStatisticsApi('registered', appChannel, business, function () {
                    if (channel.indexOf("&")) {
                      if (channel.split("&")[0] === "h5pro") {
                        location.href = "/application/home?appChannel=xhqbcs"
                      }
                    } else {
                      if (channel === "h5pro") {
                        location.href = "/application/home?appChannel=xhqbcs"
                      }
                    }
                  })
                } else {
                  magnus.clickHandle('xhqbFrontEndH5Click29Num', {
                    login_status: 1,
                  }, {
                    result: resp.result || '失败',
                    fail_reason: resp.resultMsg || '失败',
                    page_status: status,
                    page_embed_source: 3,
                    channel_id: appChannel,
                  })
                  BUSINESS_GROUP === "BGXWD" && xha.trackEvent('RegiResult', {
                    $title: '竹叶小微注册下载结果页',
                    channel_id: appChannel,
                    fail_reason: resp.resultMsg || '失败',
                    result: '0'
                  })
                  //如果跳转网页就改变页面状态
                  if (channel && (channel.split("&")[0] === "h5pro" || channel === "h5pro")) {
                    location.href = "/application/home?appChannel=xhqbcs"
                  } else {
                    if (resp.resultCode === 'REGISTER_USER_EXIST') {
                      this.newOurStatisticsApi('login', appChannel, business, function () {
                        if (channel.indexOf("&")) {
                          if (channel.split("&")[0] === "h5pro") {
                            location.href = "/application/home?appChannel=xhqbcs"
                          }
                        } else {
                          if (channel === "h5pro") {
                            location.href = "/application/home?appChannel=xhqbcs"
                          }
                        }
                      })
                      this.$refs.toast.show('用户已存在，请先下载或直接登录App客户端！', 2000, () => {
                        clearInterval(this.interval)
                        this.disabled = false
                      })
                      if (this.isZxhAppSimple) {
                        this.captcha = '' //清空验证码
                        document.getElementById("captcha-dialog").remove() //隐藏弹窗
                        this.isGetCaptcha = false
                      }
                      BUSINESS_GROUP === "BGXWD" && xha.trackEvent('EnterPageV2', {
                        $title: '竹叶小微注册下载结果页',
                        channel_id: appChannel,
                        platform_type: 'H5',
                        page_status: '',
                        page_access_time: Date.now(),
                        enterTime: getTimer(),
                        $url: location.href
                      })
                      if (this.isZxhAppSimple && openPageType === 'XCX') {
                        this.openMiniApp()
                      } else {
                        this.pageStatus = 'completed'
                      }
                      this.registerResult = 'EXIST_USER'
                      if (this.isZxhAppCommon) {
                        this.downloadBtnCounter()
                        this.clickDownloadApp()
                        //名额倒计时
                        this.handleTimeDown()
                        localStore.set('zxhPhone', this.phoneNumber)
                      }
                      if (BUSINESS_GROUP !== 'BGXWD') {
                        xha.trackEvent('RegiResult', {
                          channel_id: appChannel,
                          fail_reason: '已注册用户-注册失败',
                          result: '0'
                        })
                      }
                    } else {
                      this.$refs.toast.show(resp.resultMsg || '验证码不正确，请重新输入', 2000)
                      this.captcha = ''
                      if (BUSINESS_GROUP !== 'BGXWD') {
                        xha.trackEvent('RegiResult', {
                          channel_id: appChannel,
                          fail_reason: resp.resultMsg,
                          result: '0'
                        })
                      }
                    }
                  }
                }
              }).catch(error => {
                this.$refs.toast.show()
                this.isSubmiting = false
                if (BUSINESS_GROUP === 'BGXWD') {
                  xha.trackEvent('RegiResult', {
                    $title: '竹叶小微注册下载结果页',
                    channel_id: appChannel,
                    fail_reason: 'catch error',
                    result: '0'
                  })
                } else {
                  xha.trackEvent('RegiResult', {
                    channel_id: appChannel,
                    fail_reason: errorMsg,
                    result: '0'
                  })
                }

              })
          },
          (err) => {
            console.log('getIsXhCustomer error', err)
          }
        )
      }
    },

    // 尊享花 APP(简版) 选择打开小程序
    openMiniApp() {
      const newAppChannel = `${appChannel}&flowPath=${this.pageDetail}`
      const params = {
        appChannel: appChannel ? newAppChannel : '',
        service: 'wxAppletJsj',
        path: 'pages/home/index'
      }
      this.getMiniAppScheme(params)
    },

    download(e) {
      magnus.clickHandle('xhqbFrontEndH5Click30Num',
        {
          login_status: 1,
          element_content: '下载APP'
        },
        {
          page_embed_source: 3,
          page_status: status,
          channel_id: appChannel
        })
      if (BUSINESS_GROUP !== 'BGXWD') {
        xha.trackEvent('ElementClickV2', {
          elementType: '按钮',
          $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花注册下载页' : '小花钱包注册下载页',
          $url: location.href,
          elementName: '立即下载',
          elementText: '立即下载',
          platform_type: 'H5'
        })
      }

      if (this.downloading) {
        return
      }

      const downloadChannel = getDownloadChannel(appChannel)

      showLoading()
      this.downloading = true
      let _this = this

      let isIos = false
      setTimeout(() => {
        let jumpUrl = ''
        if (grantPlatform === 'alhc') { // 若投放平台是阿里汇川
          jumpUrl = 'https://dl.xh1.cn/Android/prod/xinxiliu01.apk'
        } else {
          if (isWeChat || md.match(/\sQQ/i)) {
            if (BUSINESS_GROUP == 'BGXWD') {
              jumpUrl = 'https://apps.bytesfield.com/download/basic/cur/df5c15c099dc74431b7edcd4bc4838dfacc14892'
            } else {
              jumpUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app'
            }
          } else if (md.os() === 'iOS') {
            if (BUSINESS_GROUP == 'BGXWD') {
              jumpUrl = 'https://apps.apple.com/cn/app/id1549160861';//打开App store上的竹叶小微
            } else {
              isIos = true
              _this.downloadApp()
              // jumpUrl = 'https://apps.apple.com/us/app/%E6%96%B0%E5%B0%8F%E8%8A%B1%E9%92%B1%E5%8C%85/id1580545905';//打开App store上的新小花钱包
            }
          } else if (md.os() === 'AndroidOS') {
            if (appChannel.startsWith('jr-')) {
              if (BUSINESS_GROUP == 'BGXWD') {
                jumpUrl = 'https://apps.bytesfield.com/download/basic/cur/df5c15c099dc74431b7edcd4bc4838dfacc14892'
              } else {
                jumpUrl = 'https://apps.bytesfield.com/download/basic/cur/9dcfeeb7220ace6c577e2b6dd2ce3bfaf0d8630b'
              }
            } else if (BUSINESS_GROUP == 'BGXWD') {
              jumpUrl = `https://apps.bytesfield.com/download/basic/cur/df5c15c099dc74431b7edcd4bc4838dfacc14892`
            } else {
              jumpUrl = `https://dl.xhqbapp.com/Android/prod/${downloadChannel}.apk`
            }
          } else {
            if (BUSINESS_GROUP == 'BGXWD') {
              jumpUrl = 'https://apps.bytesfield.com/download/basic/cur/df5c15c099dc74431b7edcd4bc4838dfacc14892'
            } else {
              jumpUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app'
            }
          }
        }
        xha.trackEvent('ElementClickV2', {
          $title: '落地页点击下载app',
          url: jumpUrl,
          business: BUSINESS_GROUP
        })
        BUSINESS_GROUP == 'BGXWD' && xha.trackEvent('ElementClickV2', {
          $title: '竹叶小微注册下载结果页',
          page_status: '',
          $url: location.href,
          elementName: '下载APP',
          element_text: '下载APP',
          elementType: '按钮',
          platform_type: 'H5',
          target_page_title: jumpUrl
        })
        if (!isIos) { //当业务线是小花钱包或者尊享花 且设备是iOS的话，不走该跳转 走跳转小程序
          location.href = jumpUrl
        }
      }, 200)
      setTimeout(() => {
        this.downloading = false
        closeLoading()
      }, 2000)
    },

    getEncryption() {
      const key = CryptoJS.enc.Utf8.parse('b8ccedeb8ea8b497') //十六位十六进制数作为密钥
      const iv = CryptoJS.enc.Utf8.parse('0123456789ABCDEF') //十六进制数作为密钥偏移量
      const productId = '小花钱包:' + getParam('productId');
      let src = CryptoJS.enc.Utf8.parse(productId);
      let enc = CryptoJS.AES.encrypt(src, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      this.encryption = enc.ciphertext.toString().toUpperCase();
      const button = document.getElementById("submitBtn");
      button.setAttribute('data-clipboard-text', this.encryption);
    },
    copyToClipboard() {
      this.getEncryption();
      const clipboard = new Clipboard("#submitBtn");
      clipboard.on("success", (e) => {
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制");
        clipboard.destroy();
      });
    },
    check(num) {
      if (num == 1) {
        if (BUSINESS_GROUP === 'BGXWD') {
          xha.trackEvent('ElementClickV2', {
            $title: '竹叶小微注册下载页',
            elementName: '勾选协议',
            elementType: '勾选框',
            page_status: '',
            $url: location.href,
            element_text: '',
            platform_type: 'H5'
          })
        } else {
          xha.trackEvent('ElementClickV2', {
            $title: BUSINESS_GROUP === 'BGALL-ZXH' ? '尊享花注册下载页' : '小花钱包注册下载页',
            elementName: '勾选协议',
            elementType: '勾选框',
            page_status: '',
            $url: location.href,
            element_text: '',
            platform_type: 'H5'
          })
        }

        document.getElementById("unselect").style.display = 'none'
        document.getElementById("select").style.display = 'block'
        document.getElementById("submitBtn").disabled = false
      } else {
        document.getElementById("unselect").style.display = 'block'
        document.getElementById("select").style.display = 'none'
        document.getElementById("submitBtn").disabled = true
      }
    },
    handleDownloadApp() {
      let title = ''
      if (BUSINESS_GROUP === 'BGXWD') {
        title = '竹叶小微注册下载页'
      } else if (BUSINESS_GROUP === 'BGALL-ZXH') {
        title = '尊享花注册下载页'
      } else {
        title = '小花钱包注册下载页'
      }
      xha.trackEvent('ElementClickV2', {
        $title: title,
        $url: location.href,
        platform_type: 'H5'
      })
      this.downloadApp()
    },
    // 点击无法下载App
    unableDownload() {
      xha.trackEvent('ElementClickV2', {
        elementName: '无法下载App',
        $url: location.href,
        platform_type: 'H5'
      })
      let _this = this;
      _this.$dialog({
        title: '长按复制并用浏览器打开',
        message: downloadLink,
        btns: [
          {
            text: '取消',
            className: 'dialog-btn-cancel',
          },
          {
            text: '点击一键复制',
            className: 'dialog-btn-confirm-zxh',
            handle() {
              let clipboard = new Clipboard(".dialog-btn-confirm-zxh", {
                text: function () {
                  return downloadLink
                }
              })
              clipboard.on("success", (e) => {
                _this.$refs.toast.show('复制成功')
                // 释放内存
                clipboard.destroy();
              });
              clipboard.on("error", (e) => {
                // 不支持复制
                _this.$refs.toast.show('该网页不支持自动复制')
                clipboard.destroy();
              });
            }
          }
        ]
      });
    }
  },
})

function getDownloadChannel(appChannel) {
  const channelList = ['shuisj', 'jingy', 'daikwy', 'fengs', 'jielm', '51xyk', 'rongzj', 'sudzj']
  if (channelList.indexOf(appChannel.replace(/\d/gi, '')) > -1) {
    return appChannel + '00'
  } else {
    return 'xhqb01'
  }
}



// WEBPACK FOOTER //
// ./web/js/generate-template/index1.js